import React from 'react';
import './ServiceBlock.css'

const ServiceList = ({ services, selectedService, onSelect }) => {
  return (
    <div className="service-list-container">
      <ul>
        {services.map((service) => (
          <li
            key={service.id}
            className={service.id === selectedService.id ? 'selected' : ''}
            onClick={() => onSelect(service)}
          >
           <service.icon size={24} /> <h4>{service.title}</h4>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ServiceList;
